

import CookieConsent,{ getCookieConsentValue } from "react-cookie-consent";
import { connect } from 'react-redux'
import {addLayerUrl, changeBanner} from '../redux';
import {fetchPath,selectNewIndex, selectNewMarkerStart, selectNewMarkerEnd,changeNomeFermataStart,changeNomeFermataEnd} from '../redux'
import React, { Component } from 'react'

function Cookie(props){
    function setCookie(cName, cValue, expDays) {
      try {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + ";SameSite=None;Secure"; // + "; path=/";
      } catch (error){}
    }

    function readCookie(name) {
      var c = document.cookie.split('; '),
      cookies = {}, i, C;
      for (i = c.length - 1; i >= 0; i--) {
          C = c[i].split('=');
          cookies[C[0]] = C[1];
        }
        return cookies[name];
    }

if(readCookie('cookie-agreed') == null){
  setCookie('cookie-agreed', 2, 1)
  /*
 return(
         <CookieConsent 
        location="bottom"
        buttonText="ACCETTA"
        declineButtonText="NO,GRAZIE"
        style={{ background : "#d71920",height:"100px",zIndex:1201}}
        
        buttonStyle={{ background : "#d71920",color: "white", fontSize: "15px",border: "2px solid #fff",fontWeight: "bolder",padding: "12px 30px",right: "300px",position: "absolute",bottom: "10%",width:"150px",borderRadius:"10px"}}
        declineButtonStyle={{ background : "white",color: "#d71920", fontSize: "15px",border: "1px solid #fff",fontWeight: "bolder",padding: "12px 30px",right: "130px",position: "absolute",bottom: "10%",width:"150px",borderRadius:"10px" }}
        enableDeclineButton={true}
        onAccept = {() => {setCookie('cookie-agreed', 2, 1)
        props.changeBanner(true)}}
        onDecline = {()=> {setCookie('cookie-agreed', 0, 1)}}
         debug={true} >
           
           <p style={{textAlign:"left",fontWeight: "bold", fontSize: "15px",fontFamily:"Titillium Web"}}>Il presente sito fa uso di cookie che consentono di fornire una migliore esperienza di navigazione all'utente.</p>
          <p style={{textAlign:"left",fontWeight: "bold", fontSize: "15px",fontFamily:"Titillium Web"}}>Cliccando "Accetta" autorizzi l’uso dei cookie sul tuo dispositivo.<a href="/privacy" textAlign="left" fontWeight= "bold" fontSize= "15px" fontFamily="Titillium Web">Maggiori informazioni</a></p>
        </CookieConsent>  
 )
 */

 }else{
    
    
    //props.changeBanner(true)
     return(
         
         <div></div>
     )
 }


}
const mapStateToProps = state => {
    return {
        pathData: state.path,
        indexData: state.index,
        positionStart: state.positionStart,
        positionEnd: state.positionEnd,
        markerStart: state.markerStart,
        markerEnd: state.markerEnd,
        position:state.position,
        nomeFermataStart: state.nomeFermataStart,
        nomeFermataEnd:state.nomeFermataEnd,
        banner : state.banner
  
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        fetchPath: (url,nome) => dispatch(fetchPath(url,nome)),
        selectIndex: (index) => dispatch(selectNewIndex(index)),
        markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
        markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
        changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changeBanner: (banner) => dispatch(changeBanner(banner))
    }
  }

  export default connect(mapStateToProps,mapDispatchToProps)(Cookie)